export default __webpack_public_path__ + "static/img/vogue_scene_animated_0541.4b774ff.jpg";